// メッセージMap
export const MessageMap = {
    "organization_type": "開示する組織タイプ",
    "useful_title": "タイトル",
    "useful_url": "URL",
    "useful_comment": " コメント",
};